"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ads = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reduxConnect = require("redux-connect");

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _reactRouterRedux = require("react-router-redux");

var _ads = require("../../redux/modules/ads");

var _RadioGroupInline = require("../../components/form/RadioGroupInline");

var _RadioGroupInline2 = _interopRequireDefault(_RadioGroupInline);

var _Button = require("../../components/form/Button");

var _Button2 = _interopRequireDefault(_Button);

var _AdSearchSelect = require("../../components/ads/AdSearchSelect");

var _AdSearchSelect2 = _interopRequireDefault(_AdSearchSelect);

var _AdsUtil = require("../../utils/AdsUtil");

var _Ad = require("../../components/ads/Ad");

var _Ad2 = _interopRequireDefault(_Ad);

var _AdsMap = require("../../components/map/AdsMap");

var _AdsMap2 = _interopRequireDefault(_AdsMap);

var _UserUtil = require("../../utils/UserUtil");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _reactDatepicker = require("react-datepicker");

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _Input = require("../../components//form/Input");

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ads = exports.Ads = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Ads, _Component);

  function Ads(props) {
    (0, _classCallCheck3.default)(this, Ads);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Ads.__proto__ || (0, _getPrototypeOf2.default)(Ads)).call(this, props));

    _this.handleButtonClick = function () {
      _this.props.pushRoute("/jata-ilmoitus");
    };

    _this.state = {
      showPriveteAdsOnly: false,
      showClosedAdsOnly: false,
      deliveryStartDate: null,
      deliveryEndDate: null,
      orderByDeliveryDates: false
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleDeliveryStartDateChange = _this.handleDeliveryStartDateChange.bind(_this);
    _this.handleDeliveryEndDateChange = _this.handleDeliveryEndDateChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Ads, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var ad_type = this.props.fields.ad_type;

      var currentPath = this.props.location.pathname;

      if (currentPath === "/ilmoitukset/tarjottavat") {
        ad_type.onChange("supplierAd");
      }

      var adId = this.props.params.adId;

      var selectedAd = this.props.ads.find(function (ad) {
        return ad.id === parseInt(adId, 10);
      });

      if (selectedAd && selectedAd.ad_type === "supplierAd") {
        ad_type.onChange("supplierAd");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props$fields = this.props.fields,
          ad_type = _props$fields.ad_type,
          postal_area = _props$fields.postal_area,
          soil_type_id = _props$fields.soil_type_id;


      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Selaa ilmoituksia" }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "div",
              { className: "ads-map-container" },
              _react2.default.createElement(
                "h2",
                { className: "h4 ads-map-title" },
                "Hakutulokset"
              ),
              _react2.default.createElement(_AdsMap2.default, {
                ads: this.getFilteredAds(),
                soilTypes: this.props.soilTypes,
                user: this.props.user
              })
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12 col-sm-6" },
            _react2.default.createElement(
              "div",
              { className: "ads-type-select" },
              _react2.default.createElement(_RadioGroupInline2.default, {
                name: "ad_type",
                fieldProps: ad_type,
                options: [{
                  id: "receiverAd",
                  value: "receiverAd",
                  title: "Vastaanottavien haku"
                }, {
                  id: "supplierAd",
                  value: "supplierAd",
                  title: "Tarjoavien haku"
                }]
              })
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_AdSearchSelect2.default, {
              placeholder: "Kaikki paikkakunnat",
              fieldProps: postal_area,
              options: this.getPostalAreas()
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_AdSearchSelect2.default, {
              placeholder: "Kaikki maa-ainekset",
              fieldProps: soil_type_id,
              options: this.props.soilTypes
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-3" },
            _react2.default.createElement(
              "label",
              { htmlFor: "delivery_start_date" },
              this.geDeliveryTitle(),
              " alku pvm"
            ),
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(_reactDatepicker2.default, {
              fixedHeight: true,
              id: "delivery_start_date",
              dateFormat: "D.M.YYYY",
              locale: "fi_FI",
              selected: this.state.deliveryStartDate,
              onChange: this.handleDeliveryStartDateChange,
              placeholderText: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4",
              maxDate: this.state.deliveryEndDate
              // fieldProps={delivery_start_date}
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-3" },
            _react2.default.createElement(
              "label",
              { htmlFor: "delivery_end_date" },
              this.geDeliveryTitle(),
              " loppu pvm"
            ),
            _react2.default.createElement("br", null),
            _react2.default.createElement(_reactDatepicker2.default, {
              fixedHeight: true,
              id: "delivery_end_date",
              dateFormat: "D.M.YYYY",
              locale: "fi_FI",
              selected: this.state.deliveryEndDate,
              onChange: this.handleDeliveryEndDateChange,
              placeholderText: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4",
              minDate: this.state.deliveryStartDate
            })
          ),
          _react2.default.createElement("div", { className: "col col-sm-6" })
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "div",
              { className: "ads-container" },
              _react2.default.createElement(
                "h3",
                { className: "h4 ads-title" },
                this.getAdsTitle()
              ),
              _react2.default.createElement(
                "div",
                { className: "checkbox-single" },
                _react2.default.createElement(
                  "label",
                  null,
                  "N\xE4yt\xE4 vain sis\xE4iset ilmoitukset:",
                  _react2.default.createElement("input", {
                    name: "showPriveteAdsOnly",
                    type: "checkbox",
                    checked: this.state.showPriveteAdsOnly,
                    onChange: this.handleInputChange
                  })
                )
              ),
              this.renderAds()
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-4 col-sm-offset-8" },
            _react2.default.createElement(_Button2.default, {
              text: "J\xE4t\xE4 ilmoitus",
              additionalClasses: "button-set-width ads-button",
              onClick: this.handleButtonClick
            })
          )
        )
      );
    }
  }, {
    key: "handleDeliveryStartDateChange",
    value: function handleDeliveryStartDateChange(date) {
      this.setState({
        deliveryStartDate: date,
        orderByDeliveryDates: true
      });
      this.getFilteredAds();
    }
  }, {
    key: "handleDeliveryEndDateChange",
    value: function handleDeliveryEndDateChange(date) {
      this.setState({
        deliveryEndDate: date,
        orderByDeliveryDates: true
      });
      this.getFilteredAds();
    }
  }, {
    key: "getPostalAreas",
    value: function getPostalAreas() {
      var ads = this.props.ads;

      var postalAreas = [];
      if (!ads) {
        return;
      }
      ads.forEach(function (ad) {
        var postalArea = postalAreas.find(function (area) {
          return area.name.toLowerCase() === ad.postal_area.toLowerCase();
        });
        if (!postalArea) {
          postalAreas.push({ id: ad.postal_area, name: ad.postal_area });
        }
      });
      return postalAreas.sort(function (a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (b.name > a.name) {
          return -1;
        }
        return 0;
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.type === "checkbox" ? target.checked : target.value;
      var name = target.name;
      this.setState((0, _defineProperty3.default)({}, name, value));
    }
  }, {
    key: "getAdsTitle",
    value: function getAdsTitle() {
      var ad_type = this.props.fields.ad_type;

      return ad_type.value === "supplierAd" ? "Tarjotaan maa-ainesta" : "Vastaanotetaan maa-ainesta";
    }
    // @@ TODO:  : hide this. if: visible = true ? hide : show
    // @@ FIXME: have to enhance if Advertisement attrib visibility on or off

  }, {
    key: "renderAds",
    value: function renderAds() {
      var _this2 = this;

      var _props = this.props,
          soilTypes = _props.soilTypes,
          user = _props.user,
          params = _props.params;

      var sortedAds = this.getFilteredAds();
      if (!sortedAds.length) {
        return this.renderNoAdsNotice();
      }
      return sortedAds.map(function (ad) {
        if (user) {
          if (ad.visibility == user.company_id || ad.visibility == 0 && _this2.state.showPriveteAdsOnly == false) {
            return _react2.default.createElement(_Ad2.default, {
              key: ad.id,
              ad: ad,
              soilTypes: soilTypes,
              user: user,
              params: params
            });
          }
        } else {
          if (ad.visibility == 0) {
            return _react2.default.createElement(_Ad2.default, {
              key: ad.id,
              ad: ad,
              soilTypes: soilTypes,
              user: user,
              params: params
            });
          }
        }
      });
    }
  }, {
    key: "renderNoAdsNotice",
    value: function renderNoAdsNotice() {
      return _react2.default.createElement(
        "div",
        { className: "ads-notice" },
        _react2.default.createElement(
          "p",
          null,
          "Hakuehdoillasi ei l\xF6ytynyt yht\xE4\xE4n ilmoitusta. Muokkaa hakuehtoja ja yrit\xE4 uudelleen. J\xE4tt\xE4m\xE4ll\xE4 oman ilmoituksen parannat merkitt\xE4v\xE4sti mahdollisuutta l\xF6yt\xE4\xE4 sen mit\xE4 olet etsim\xE4ss\xE4."
        )
      );
    }
  }, {
    key: "geDeliveryTitle",
    value: function geDeliveryTitle() {
      var ad_type = this.props.fields.ad_type;

      return ad_type.value === "supplierAd" ? "Tarjotaan" : "Vastaanoton";
    }
  }, {
    key: "getFilteredAds",
    value: function getFilteredAds() {
      var _props2 = this.props,
          fields = _props2.fields,
          ads = _props2.ads,
          user = _props2.user;

      var filteredAds = (0, _AdsUtil.filterAdsBySearchOptions)(fields, ads, true);
      filteredAds = (0, _AdsUtil.sortAdsByDate)(filteredAds);

      if (user) {
        if (this.state.orderByDeliveryDates) {
          filteredAds = (0, _AdsUtil.filterAdsByDeliveryDates)(filteredAds, this.state.deliveryStartDate, this.state.deliveryEndDate);
        }
        return filteredAds;
      }
      return filteredAds;
    }
  }]);
  return Ads;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object,
  ads: _react.PropTypes.array.isRequired,
  soilTypes: _react.PropTypes.array.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  location: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object.isRequired
}, _temp);
exports.default = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];

    //  if (!isAdsLoaded(getState())) {
    promises.push(dispatch((0, _ads.loadAds)()));
    //   }

    return _promise2.default.all(promises);
  }
}])((0, _reactRedux.connect)(function (state) {
  return {
    ads: state.ads.ads,
    soilTypes: state.ads.soilTypes,
    user: state.auth.user
  };
}, {
  pushRoute: _reactRouterRedux.push
})((0, _reduxForm.reduxForm)({
  form: "ads",
  fields: ["ad_type", "postal_area[]", "soil_type_id[]"],
  initialValues: {
    ad_type: "receiverAd"
  }
})(Ads)));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Ads/Ads.js
 ** module id = 1204
 ** module chunks = 0
 **/